// extracted by mini-css-extract-plugin
export default {"detailsLabel":"styles-module__d6oDl"};